import React, { useState, useEffect } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import ApiFetch from '../ApiFetch';
import { arrayShuffle, imageUrl } from '../../service/CommonUtil';
import { Link, useNavigate } from 'react-router-dom';

const TaggedImageSlider = () => {
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate()

    useEffect(() => {
        fetchPopularImages();
    }, []);

    const fetchPopularImages = async () => {
        try {
            const response = await fetch(ApiFetch.API_PROTOCOL + "//" + ApiFetch.API_HOST + '/v1/tag/popularTaggedImages/2');
            const result = await response.json();
            if (result.result) {
                if(result.data.length === 0){
                    setImages([
                        {
                          "tag_id": "6293edf0-e4a9-4a0b-8f75-0e754e2d9799",
                          "tag": "animaPencilXL_v300",
                          "usage_count": 60,
                          "group_id": "36060b94-5e59-4efa-b564-a71e7cc9d976",
                          "title": "願い",
                          "description": "#願掛け\r\n#animaPencilXL_v300 #プロンプトあり",
                          "favorite_count": 11
                        },
                        {
                          "tag_id": "03ae650a-b8a7-4163-be02-05508498e0ca",
                          "tag": "animaPencilXL_v400",
                          "usage_count": 104,
                          "group_id": "542bd09e-19ec-4fd0-be97-66926ebd6632",
                          "title": "鬼も食っていいだろう",
                          "description": "サーモンの薄切りで巻いた豪華な恵方巻を食う鬼\r\n\r\n#鬼 #節分\r\n#animaPencilXL_v400 #プロンプトあり",
                          "favorite_count": 9
                        },
                        {
                          "tag_id": "72ee93f1-e4ef-4a7a-9a36-f136fa1461a0",
                          "tag": "asyncsMIX_v6",
                          "usage_count": 369,
                          "group_id": "934ec077-9375-49b5-8e6d-25c51df682c1",
                          "title": "魔法陣",
                          "description": "#asyncsMIX_v6 #プロンプトあり",
                          "favorite_count": 7
                        },
                        {
                          "tag_id": "8d3a01d5-52d9-4f37-a572-5eef2beb17ca",
                          "tag": "DALL_E3",
                          "usage_count": 2575,
                          "group_id": "daf2b064-45ba-4070-9398-36c14e47ac8f",
                          "title": "玩偶の囁き、創造の残響",
                          "description": "天上を模倣した人間の創造、\n人間を模倣する機械の歌、\n玩偶だけが孤独を知っている。\n#みめっとの深層画廊\n#DALL_E3 #t2i",
                          "favorite_count": 12
                        },
                        {
                          "tag_id": "1066e275-b91c-47af-b5e1-aeb18801bc19",
                          "tag": "holodayo_xl_2.1",
                          "usage_count": 139,
                          "group_id": "f1c780ad-176b-4f33-abfd-5024249b5236",
                          "title": "ガールドール",
                          "description": "#アニメキャラクター #人形風 #オレンジ髪 #青い目 #ホワイトドレス #青いリボン #サマーアウトフィット #座っているポーズ #少女 #ロングヘア #背景に森林 #コミカライズスタイル #カートゥーン風 #表情が無表情 #デフォルメ #アニメーター #アートスタイル #シンプルなデザイン #スムーズなライン #かわいい #柔らかな色合い #自然光 #アニメ風背景 #木々の間 #視線向き正面 #人形らしさ #服のディテール #肩出し #足を組んでいる #キャラクター造形 #平面構成 #デジタルアート #幻想的な雰囲気 #非現実的 #ジャパニーズアート #カスケードヘア #ファンアート #オリジナルキャラクター #テクスチャーのない肌 #美少女風デザイン\r\n#holodayo_xl_2.1\r\n#ネコネルの美少女イラスト #プロンプトあり",
                          "favorite_count": 14
                        }
                      ])
                } else {
                    setImages(arrayShuffle(result.data));
                }
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return "";
    }

    return (
        <Box sx={{ position: 'relative', maxWidth: '100%', my: 2, px: 4 }}>
            <Swiper
                spaceBetween={2}
                slidesPerView={6}
                navigation={{
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                }}
                breakpoints={{
                    320: { slidesPerView: 2 },
                    480: { slidesPerView: 3 },
                    768: { slidesPerView: 4 },
                    1024: { slidesPerView: 6 },
                }}
            >
                {images.map((image) => (
                    <SwiperSlide key={image.group_id}>
                        <Box
                            sx={{
                                position: 'relative',
                                width: '150px',
                                height: '75px',
                                borderRadius: '12px',
                                overflow: 'hidden',
                                cursor: 'pointer',
                                '&:hover': {
                                    '& .tag-overlay': {
                                        backgroundColor: 'rgba(0, 0, 0, 0.7)',
                                    }
                                },
                                zIndex: 1,
                            }}
                        >
                            <Box
                                component="img"
                                src={imageUrl(image, "image")}
                                alt={image.title}
                                sx={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                }}
                            />
                            <Box
                                className="tag-overlay"
                                sx={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundColor: 'rgba(0, 0, 0, 0.3)',
                                    transition: 'background-color 0.3s ease',
                                }}
                                onClick={() => navigate("/tag/" + encodeURI(image.tag) + "/1")}
                            >
                                <Typography
                                    sx={{
                                        color: 'white',
                                        fontSize: '0.9rem',
                                        fontWeight: 'bold',
                                        textAlign: 'center',
                                        px: 1,
                                    }}
                                >
                                    #{image.tag}
                                </Typography>
                            </Box>
                        </Box>
                    </SwiperSlide>
                ))}
            </Swiper>
        </Box>
    );
};

export default TaggedImageSlider;